<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary"
    class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal" v-esc="escape">
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>{{ Object.entries(this.data).length === 0 ? "Yeni Distributor" : "Distributor Düzenle" }}</h4>
      <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>
    <VuePerfectScrollbar class="scroll-area--data-list-add-new" :settings="settings">
      <form data-vv-scope="form-1" @keyup.enter="submitData">
        <div class="px-6">

          <v-select :disabled="suppliers.length == 0" id="supplier" v-validate="'required'" name="Tedarikçi"
            v-model="selectedSupplier" itemid="id" label="name" placeholder="Tedarikçi Seçimi.." :options="suppliers"
            class="mt-4" :clearable="true"></v-select>
          <span v-if="selectedSupplier != null" class="text-danger text-sm"
            v-show="errors.has('form-1.Tedarikçi')">{{ errors.first('form-1.Tedarikçi') }}</span>

          <vs-checkbox class="mt-4" v-if="selectedSupplier != null" v-model="isUseSupplierData">Tedarikçi Bilgilerini
            Kullan</vs-checkbox>

          <vs-input :disabled="isUseSupplierData" id="name" name="İsim" v-validate="'required|min:2|max:40'"
            v-model="newDistributor.name" class="w-full" icon-pack="feather" icon="icon-user"
            label-placeholder="Distributor İsmi" />
          <span v-if="selectedSupplier != null" class="text-danger text-sm"
            v-show="errors.has('form-1.İsim')">{{ errors.first('form-1.İsim') }}</span>

          <vs-input :disabled="isUseSupplierData" id="ownerName" name="Yetkili İsmi" v-validate="'min:2|max:40'"
            v-model="newDistributor.ownerName" class="w-full" icon-pack="feather" icon="icon-user"
            label-placeholder="Distributor Yetkili İsmi" />
          <span v-if="selectedSupplier != null" class="text-danger text-sm"
            v-show="errors.has('form-1.Yetkili İsmi')">{{ errors.first('form-1.Yetkili İsmi') }}</span>

          <vs-input :disabled="isUseSupplierData" id="email" name="Email" v-validate="'email|min:4|max:50'" type="email"
            v-model="newDistributor.email" class="w-full" icon-pack="feather" icon="icon-mail"
            label-placeholder="Email" />
          <span v-if="selectedSupplier != null" class="text-danger text-sm"
            v-show="errors.has('form-1.Email')">{{ errors.first('form-1.Email') }}</span>

          <vs-input :disabled="isUseSupplierData" id="phone" name="Telefon" v-mask="phoneMask" v-validate="'length:14'"
            v-model="newDistributor.phoneNumber" class="w-full" icon-pack="feather" icon="icon-phone"
            label-placeholder="Telefon" />
          <span v-if="selectedSupplier != null" class="text-danger text-sm"
            v-show="errors.has('form-1.Telefon')">{{ errors.first('form-1.Telefon') }}</span>

          <vs-input :disabled="isUseSupplierData" id="fax" name="Fax" v-mask="faxMask" v-validate="'length:14'"
            v-model="newDistributor.fax" class="w-full" icon-pack="feather" icon="icon-phone" label-placeholder="Fax" />
          <span v-if="selectedSupplier != null" class="text-danger text-sm"
            v-show="errors.has('form-1.Fax')">{{ errors.first('form-1.Fax') }}</span>

          <vs-textarea :disabled="isUseSupplierData" id="Adres" name="Adres" v-model="newDistributor.address"
            class="w-full mt-4 mb-0" label="Adres" />

          <v-select :disabled="isUseSupplierData" id="bank" name="Banka" v-model="newDistributor.bank" itemid="id"
            label="name" placeholder="Banka Seçimi.." :options="banks" class="mt-4" :clearable="true"></v-select>
          <span v-if="selectedSupplier != null" class="text-danger text-sm"
            v-show="errors.has('form-1.Banka')">{{ errors.first('form-1.Banka') }}</span>

          <vs-textarea :disabled="isUseSupplierData" id="bankAccount" name="Hesap Bilgileri"
            v-model="newDistributor.bankAccount" class="w-full mt-4 mb-0" icon-pack="feather" icon="icon-calendar"
            label="Banka Hesap Bilgileri" />
          <span v-if="selectedSupplier != null" class="text-danger text-sm"
            v-show="errors.has('form-1.Hesap Bilgileri')">{{ errors.first('form-1.Hesap Bilgileri') }}</span>

          <vs-textarea :disabled="isUseSupplierData" id="description" name="Açıklama"
            v-model="newDistributor.description" class="w-full mt-4 mb-0" icon-pack="feather" icon="icon-calendar"
            label="Açıklama" />

        </div>
      </form>
      <div class="flex mt-5 px-6 pb-4">
        <vs-button class="mr-auto" type="gradient" color="danger" @click="isSidebarActiveLocal = false">
          Vazgeç
        </vs-button>
        <vs-button class="ml-auto" color="success" @click="submitData">Kaydet</vs-button>
      </div>
    </VuePerfectScrollbar>
  </vs-sidebar>
</template>

<script>
  import VuePerfectScrollbar from 'vue-perfect-scrollbar'
  import {
    createNewDistributor,
    updateDistributor
  } from '@/api/Distributor';
  import {
    getSupplierNameList
  } from "@/api/Supplier"
  export default {
    props: {
      isSidebarActive: {
        type: Boolean,
        required: true
      },
      data: {
        type: Object,
        default: () => {},
      }
    },
    data() {
      return {
        backUpData: {},
        isUseSupplierData: false,
        suppliers: [],
        selectedSupplier: null,
        banks: ['Ziraat', 'Garanti', 'HSBC', 'Vakıfbank', 'Finansbank', 'Yapıkredi', 'TEB', 'Halkbank'],
        phoneMask: "#### ### ## ##",
        faxMask: "#### ### ## ##",
        newDistributor: {
          fax: "",
          phoneNumber: "",
          bank: ""
        },

        settings: { // perfectscrollbar settings
          maxScrollbarLength: 60,
          wheelSpeed: .60,
        },
      }
    },
    computed: {
      isSidebarActiveLocal: {
        get() {
          return this.isSidebarActive
        },
        set(val) {
          if (!val) {
            this.$emit('closeSidebar')
            this.$validator.reset()
            this.initValues()
          }
        }
      }
    },
    methods: {
      escape() {
        if (this.isSideBarActiveLocal) this.isSideBarActiveLocal = false;
      },
      syncSupplierAndDistributor() {
        let supp = this.selectedSupplier;
        let id = 0;
        if (this.newDistributor.id != null) {
          id = this.newDistributor.id
        }
        this.newDistributor = {
          name: supp.name,
          description: supp.description,
          address: supp.address,
          bankAccount: supp.bankAccount,
          bank: supp.bank,
          fax: supp.fax,
          phoneNumber: supp.phoneNumber,
          email: supp.email,
          ownerName: supp.ownerName,
          id: id
        }
      },
      getSupplierNameList() {
        getSupplierNameList().then(res => {
          if (res && res.status == 200) {
            this.suppliers = res.data;
          } else {
            this.$vs.notify({
              color: 'danger',
              title: 'Hata : ' + res.status,
              text: 'Tedarikçi Listesi Yüklenemedi !'
            });
          }
        }).catch(err => {
          this.$vs.notify({
            color: 'danger',
            title: 'Hata !',
            text: 'Sunucu Bağlantı Hatası !'
          });
        });
      },
      initValues() {
        this.newDistributor = {
          fax: "",
          phoneNumber: "",
          bank: ""
        };
        this.selectedSupplier = null;
        this.suppliers = [];
      },
      submitData: async function () {
        let checker;
        checker = await this.$validator.validateAll('form-1');
        if (checker || this.isUseSupplierData == true) {
          this.newDistributor.supplierId = this.selectedSupplier.id;
          this.newDistributor.supplier = _.cloneDeep(this.selectedSupplier);
          if (this.newDistributor.id) {
            updateDistributor(this.newDistributor).then(res => {
              if (res && res.status == 200) {
                this.$store.dispatch("distributor/updateDistributor", res.data).then(data => {
                  this.$vs.notify({
                    color: 'success',
                    title: 'Başarılı !',
                    text: 'Distributor Güncellendi !'
                  });
                  this.$emit('closeSidebar');
                  this.initValues();
                  this.$validator.reset();
                }).catch(err => {
                  console.error(err)
                });
              } else {
                this.$vs.notify({
                  color: 'danger',
                  title: 'Hata : ' + res.status,
                  text: 'Distributor Güncellenemedi !'
                });
              }
            }).catch(() => {
              this.$vs.notify({
                color: 'danger',
                title: 'Hata !',
                text: 'Sunucu Bağlantı Hatası !'
              });
            });
          } else {
            this.newDistributor.id = 0;
            createNewDistributor(this.newDistributor).then(res => {
              if (res && res.status == 200) {
                this.$store.dispatch("distributor/addDistributor", res.data).then(data => {
                  this.$vs.notify({
                    color: 'success',
                    title: 'Başarılı !',
                    text: 'Yeni Distribütör Oluşturuldu !'
                  });
                  this.$emit('closeSidebar');
                  this.initValues();
                  this.$validator.reset();
                });
              } else {
                this.$vs.notify({
                  color: 'danger',
                  title: 'Hata : ' + res.status,
                  text: 'Distribütor Kayıt Edilemedi !'
                });
              }
            }).catch(() => {
              this.$vs.notify({
                color: 'danger',
                title: 'Hata !',
                text: 'Sunucu Bağlantı Hatası !'
              });
            });
          }
        }
      },
    },
    components: {
      VuePerfectScrollbar
    },
    watch: {
      isUseSupplierData: function (val) {
        if (val) {
          this.backUpData = _.cloneDeep(this.newDistributor);
          this.syncSupplierAndDistributor();
        } else {
          this.newDistributor = this.backUpData;
        }
      },
      selectedSupplier: function (val) {
        if (!val) this.isUseSupplierData = false;
      },
      isSidebarActive: function (val) {
        if (!val) return
        if (Object.entries(this.data).length === 0) {
          this.initValues();
          this.getSupplierNameList();
          this.$validator.reset();
        } else {
          this.getSupplierNameList();
          Object.assign(this.newDistributor, this.data); //Şurda
          this.selectedSupplier = this.newDistributor.supplier;
        }
      }
    },
    created: function () {
    },
  }

</script>

<style lang="scss" scoped>
  .vs__dropdown-menu {
    max-height: 25vh !important;
    overflow-x: hidden !important;
    overflow-y: scroll !important;
    position: absolute !important;
  }

  .style-chooser .vs__dropdown-menu {
    background: #dfe5fb;
    border: none;
    color: red;
    text-transform: lowercase;
    font-variant: small-caps;
  }

  .add-new-data-sidebar {
    ::v-deep .vs-sidebar--background {
      z-index: 52010;
    }

    ::v-deep .vs-sidebar {
      z-index: 52010;
      width: 400px;
      max-width: 90vw;

      .img-upload {
        margin-top: 2rem;

        .con-img-upload {
          padding: 0;
        }

        .con-input-upload {
          width: 100%;
          margin: 0;
        }
      }
    }
  }

  .tabPager {
    background-color: darkgreen;
    border-radius: 50%;
  }

</style>
